<template>
  <div class="card transparentCardNoBorder mgb-10px"
       :class="isNotRegie ? 'min-width-1600px' : 'min-width-1250px'">
    <div class="card-content pdv-0pdl-12px">
      <div class="columns">
        <div class="column is-narrow mgr-30px">
          <div class="columns">
            <div class="column is-6">
              <b-checkbox :value="allLignesSelect" @input="$emit('selectAll')"></b-checkbox>
            </div>
          </div>
        </div>
        <div class="column has-text-link has-text-weight-bold">
          <div class="columns">
            <div class="column is-6">
              <div class="columns">
                <div class="column"
                     :class="isNotRegie ? 'is-6' : 'is-9'">
                  {{ $t('echeancierFacturation.tabs.products') }}
                </div>
                <div class="column is-3" v-if="isNotRegie">
                  {{ $t('echeancierFacturation.tabs.fournisseur') }}
                </div>
                <div class="column is-2 has-text-right ellipsis">
                  {{ $t('echeancierFacturation.tabs.montant') }}
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="columns">
                <div class="column is-4">
                  {{ $t('echeancierFacturation.tabs.echeancier') }}
                </div>
                <div class="column ellipsis is-4">
                  {{ $t('echeancierFacturation.tabs.datePrev') }}
                </div>
                <div class="column is-2" v-if="isNotRegie">
                  {{ $t('echeancierFacturation.tabs.aFacturer') }}
                </div>
                <div class="column" :class="isNotRegie ? 'is-2' : 'is-4'">
                  {{ $t('echeancierFacturation.tabs.commentaire') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    allLignesSelect: {
      type: Boolean,
      required: true,
    },
    isNotRegie: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
